import React from 'react';
import { Message, Assistant } from '@/types';
import { MessageBubble, StreamingMessage, LoadingIndicator } from './';  // ← Updated!
interface ChatContainerProps {
    messages: Message[];
    assistant: Assistant;
    isLoading: boolean;
    streamingMessage: string;
    currentTool?: string | null;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
                                                                messages,
                                                                assistant,
                                                                isLoading,
                                                                streamingMessage,
                                                                currentTool
                                                            }) => {
    return (
        <>
            {messages.map(message => (
                <MessageBubble
                    key={message.id}
                    message={message}
                    assistant={assistant}
                />
            ))}

            {isLoading && !streamingMessage && (
                <LoadingIndicator assistant={assistant} currentTool={currentTool} />
            )}

            {streamingMessage && (
                <StreamingMessage content={streamingMessage} assistant={assistant} />
            )}

</>
    );
};